import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
// import { useNavigate, useParams } from 'react-router-dom';
// import { fetchArticles, fetchArticleContent, setActiveArticle } from '../slices/coreAssetsSlice'
import { Divider } from 'semantic-ui-react';
import infoProfessor from '../assets/thodkin_librarian_futuristic_2a188bb5-2c71-4330-a561-ef70e9707b82.png'
import ArticleArchiveTree from '../utils/articleArchiveTree'
import '../styles/article.css'

const ArticleSidebar = () => {
  let optionsList = useRef([])
  const articleList = useSelector((state) => {
    console.log('ArticleSidebar articleList', state.core.articles.articles);
    if (state.core.articles.articles) {
      optionsList.current = state.core.articles.articles.map((x) => {
        let key_value = x.name.replace(/[^a-z0-9]/gi, '').toLowerCase()
        return { key: key_value, text: x.name, value: key_value, data: x }
      })
      // console.log('allArticles', articleListOptions);

    }
    return state.core.articles.articles;
  })
  // const [currentList, setCurrentList] = useState(null)

  let createArticleOptions = (artItems) => {
    console.log('createArticleOptions', artItems)

  }
  function organizeByCategory(articles) {
    // Create an empty object to hold the categories
    let categories = {};

    // Loop through each article
    for (let article of articles) {
      // If the category does not exist in the categories object, create it
      if (!categories[article.categories[0]]) {
        categories[article.categories[0]] = { name: article.categories[0], children: [] };
      }

      // Add the article to the category
      categories[article.categories[0]].children.push({ name: article.name });
    }

    // Convert the categories object to an array
    return Object.values(categories);
  }

  useEffect(() => {
    if (articleList && articleList.length > 0) {
      optionsList.current = organizeByCategory(articleList)
      console.log('TRANSLATED LIST', optionsList.current);
      // setCurrentList(createArticleOptions(articleList))
    }
  }, [articleList])
  /**
   * ⛔ AN EMPTY ARCHIVE RENDERS NOTHING, heading included.
   *
   * The tree comes from the fetched article list. Where there is no list — a page opened by its
   * own uuid, a fetch that has not landed, a filtered list with nothing in it — this drew
   * "INFO ARCHIVE", the professor and a promise of "useful guides", over nothing at all.
   *
   * ⓘ A heading over an empty tree reads as a broken page; absence reads as a page without a
   * sidebar. The caller decides whether the column belongs at all — see ArticleItem — and this
   * covers the case where it is mounted and has nothing to show.
   */
  const items = optionsList.current;
  if (!items || !items.length) return null;

  return (
    <>
      <div className='articleSidebar-container'>
        <img src={infoProfessor} alt="Narrator" />
        <div className='articleSidebar-text-container'>
          <>
            <span className="articleSidebar-header-text">INFO ARCHIVE</span>
            <span className="articleSidebar-header-body">Useful guides to processes and a bunch of other interesting info...</span>
          </>
        </div>
        <div >
          <Divider className='articleSidebar-divider' />
          <ArticleArchiveTree artItemsList={optionsList.current} />
        </div>
      </div>

    </>
  )
}

export default ArticleSidebar;


// MATCH(b: Article { uuid: $ArticleUid })
// CREATE(bi: ArticleItem {
//   uuid: "b6579b30-5332-ac59-0038-3b4041ad7abf",
//   name: "We Get To It",
//   createdAt: date(),
//   updatedOn: date(),
//   enabled: true,
//   author: "authorboss",
//   category: "uncategorized",
//   excerpt: "Our team of developers are hard at work, making this happen...whatever it is.",
//   heroImageUrl: "https://aai-api.s3.us-west-1.amazonaws.com/aai-core/articles/news/images/thodkin_A_device_like_a_tornado_injests_book_produces_voice_pac_92e9ab2d-46f1-474c-a61f-8e3417f5e61c.png",
//   thumbnailImageUrl: "https://aai-api.s3.us-west-1.amazonaws.com/aai-core/articles/news/images/thodkin_Android_mech_as_a_scientist_at_futuristic_workstation_w_131b2096-3904-4b5b-85d7-f573c1d0f3dd.png",
//   contentUrl: "https://aai-api.s3.us-west-1.amazonaws.com/aai-core/articles/news/content/testDoc.txt",
//   content: ""
// })
